<template>
  <v-card class="d-flex align-center justify-center pa-5" outlined style="background-color: rgba(0,0,0,0); min-height: 70vh;">
    <v-container fluid>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center" src="https://hub.swiset.com/wp-content/uploads/2021/01/Tournament-Ranking.png" max-width="91px" contain/>
      </div>
      <h1 class="text-center">{{ $t('title_TournamentStopped') }}</h1>
      <h3 class="text-center">{{ $t('description', { value: $store.state.tournament.participants.length })}}</h3>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "TournamentStopped",
}
</script>

<style scoped>

</style>

